// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 525 ? "articles" : chunkId) + "." + {"525":"340bf53a","739":"96253ce8"}[chunkId] + ".css";
};